// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"practiceAreaTemplate-module--wrapper--2KooS"};